export var IMAGE_RATIO;
(function (IMAGE_RATIO) {
    IMAGE_RATIO[IMAGE_RATIO["1:1"] = 1] = "1:1";
    IMAGE_RATIO[IMAGE_RATIO["16:9"] = 2] = "16:9";
})(IMAGE_RATIO || (IMAGE_RATIO = {}));
export var LIST_IMAGE_SIZE;
(function (LIST_IMAGE_SIZE) {
    LIST_IMAGE_SIZE[LIST_IMAGE_SIZE["SMALL"] = 1] = "SMALL";
    LIST_IMAGE_SIZE[LIST_IMAGE_SIZE["MEDIUM"] = 2] = "MEDIUM";
    LIST_IMAGE_SIZE[LIST_IMAGE_SIZE["LARGE"] = 3] = "LARGE";
})(LIST_IMAGE_SIZE || (LIST_IMAGE_SIZE = {}));
export var LIST_ALIGNMENT;
(function (LIST_ALIGNMENT) {
    LIST_ALIGNMENT[LIST_ALIGNMENT["LEFT"] = 1] = "LEFT";
    LIST_ALIGNMENT[LIST_ALIGNMENT["CENTER"] = 2] = "CENTER";
    LIST_ALIGNMENT[LIST_ALIGNMENT["RIGHT"] = 3] = "RIGHT";
})(LIST_ALIGNMENT || (LIST_ALIGNMENT = {}));
export var DATE_SIZE;
(function (DATE_SIZE) {
    DATE_SIZE[DATE_SIZE["SMALL"] = 1] = "SMALL";
    DATE_SIZE[DATE_SIZE["MEDIUM"] = 2] = "MEDIUM";
})(DATE_SIZE || (DATE_SIZE = {}));
export var ALIGNMENT;
(function (ALIGNMENT) {
    ALIGNMENT[ALIGNMENT["LEFT"] = 1] = "LEFT";
    ALIGNMENT[ALIGNMENT["CENTER"] = 2] = "CENTER";
    ALIGNMENT[ALIGNMENT["RIGHT"] = 3] = "RIGHT";
})(ALIGNMENT || (ALIGNMENT = {}));
export var LIST_IMAGE_LAYOUT;
(function (LIST_IMAGE_LAYOUT) {
    LIST_IMAGE_LAYOUT[LIST_IMAGE_LAYOUT["LEFT"] = 1] = "LEFT";
    LIST_IMAGE_LAYOUT[LIST_IMAGE_LAYOUT["MIXED"] = 2] = "MIXED";
    LIST_IMAGE_LAYOUT[LIST_IMAGE_LAYOUT["RIGHT"] = 3] = "RIGHT";
})(LIST_IMAGE_LAYOUT || (LIST_IMAGE_LAYOUT = {}));
export var LIST_LOCATION_AND_DATE_FORMAT;
(function (LIST_LOCATION_AND_DATE_FORMAT) {
    LIST_LOCATION_AND_DATE_FORMAT[LIST_LOCATION_AND_DATE_FORMAT["COMPACT"] = 1] = "COMPACT";
    LIST_LOCATION_AND_DATE_FORMAT[LIST_LOCATION_AND_DATE_FORMAT["FULL"] = 2] = "FULL";
})(LIST_LOCATION_AND_DATE_FORMAT || (LIST_LOCATION_AND_DATE_FORMAT = {}));
export var LOCATION_AND_DATE_FORMAT;
(function (LOCATION_AND_DATE_FORMAT) {
    LOCATION_AND_DATE_FORMAT[LOCATION_AND_DATE_FORMAT["VERTICAL"] = 1] = "VERTICAL";
    LOCATION_AND_DATE_FORMAT[LOCATION_AND_DATE_FORMAT["HORIZONTAL"] = 3] = "HORIZONTAL";
    LOCATION_AND_DATE_FORMAT[LOCATION_AND_DATE_FORMAT["COMPACT"] = 2] = "COMPACT";
})(LOCATION_AND_DATE_FORMAT || (LOCATION_AND_DATE_FORMAT = {}));
export var LIST_LAYOUT;
(function (LIST_LAYOUT) {
    LIST_LAYOUT[LIST_LAYOUT["LIST"] = 1] = "LIST";
    LIST_LAYOUT[LIST_LAYOUT["GRID"] = 2] = "GRID";
    LIST_LAYOUT[LIST_LAYOUT["NEW_GRID"] = 3] = "NEW_GRID";
    LIST_LAYOUT[LIST_LAYOUT["SIDE_BY_SIDE"] = 4] = "SIDE_BY_SIDE";
    LIST_LAYOUT[LIST_LAYOUT["CALENDAR"] = 5] = "CALENDAR";
})(LIST_LAYOUT || (LIST_LAYOUT = {}));
export var MOBILE_LIST_LAYOUT;
(function (MOBILE_LIST_LAYOUT) {
    MOBILE_LIST_LAYOUT[MOBILE_LIST_LAYOUT["FULL"] = 1] = "FULL";
    MOBILE_LIST_LAYOUT[MOBILE_LIST_LAYOUT["COMPACT"] = 2] = "COMPACT";
})(MOBILE_LIST_LAYOUT || (MOBILE_LIST_LAYOUT = {}));
export var WIDGET_LAYOUT;
(function (WIDGET_LAYOUT) {
    WIDGET_LAYOUT[WIDGET_LAYOUT["FULL"] = 1] = "FULL";
    WIDGET_LAYOUT[WIDGET_LAYOUT["BUTTON_ONLY"] = 2] = "BUTTON_ONLY";
    WIDGET_LAYOUT[WIDGET_LAYOUT["VERTICAL"] = 3] = "VERTICAL";
    WIDGET_LAYOUT[WIDGET_LAYOUT["BACKGROUND"] = 4] = "BACKGROUND";
})(WIDGET_LAYOUT || (WIDGET_LAYOUT = {}));
export var OLD_WIDGET_LAYOUT;
(function (OLD_WIDGET_LAYOUT) {
    OLD_WIDGET_LAYOUT["FULL"] = "FULL";
    OLD_WIDGET_LAYOUT["BUTTON_ONLY"] = "BUTTON_ONLY";
    OLD_WIDGET_LAYOUT["VERTICAL"] = "VERTICAL";
    OLD_WIDGET_LAYOUT["BACKGROUND"] = "BACKGROUND";
    OLD_WIDGET_LAYOUT["HORIZONTAL"] = "HORIZONTAL";
    OLD_WIDGET_LAYOUT["RIGHT"] = "RIGHT";
})(OLD_WIDGET_LAYOUT || (OLD_WIDGET_LAYOUT = {}));
export var HORIZONTAL_IMAGE_POSITION;
(function (HORIZONTAL_IMAGE_POSITION) {
    HORIZONTAL_IMAGE_POSITION[HORIZONTAL_IMAGE_POSITION["LEFT"] = 1] = "LEFT";
    HORIZONTAL_IMAGE_POSITION[HORIZONTAL_IMAGE_POSITION["RIGHT"] = 2] = "RIGHT";
})(HORIZONTAL_IMAGE_POSITION || (HORIZONTAL_IMAGE_POSITION = {}));
export var VERTICAL_IMAGE_POSITION;
(function (VERTICAL_IMAGE_POSITION) {
    VERTICAL_IMAGE_POSITION[VERTICAL_IMAGE_POSITION["TOP"] = 1] = "TOP";
    VERTICAL_IMAGE_POSITION[VERTICAL_IMAGE_POSITION["BOTTOM"] = 2] = "BOTTOM";
})(VERTICAL_IMAGE_POSITION || (VERTICAL_IMAGE_POSITION = {}));
export var IMAGE_POSITION;
(function (IMAGE_POSITION) {
    IMAGE_POSITION[IMAGE_POSITION["CENTER_CENTER"] = 5] = "CENTER_CENTER";
})(IMAGE_POSITION || (IMAGE_POSITION = {}));
export var VERTICAL_ALIGNMENT;
(function (VERTICAL_ALIGNMENT) {
    VERTICAL_ALIGNMENT[VERTICAL_ALIGNMENT["TOP"] = 1] = "TOP";
    VERTICAL_ALIGNMENT[VERTICAL_ALIGNMENT["CENTER"] = 2] = "CENTER";
    VERTICAL_ALIGNMENT[VERTICAL_ALIGNMENT["BOTTOM"] = 3] = "BOTTOM";
})(VERTICAL_ALIGNMENT || (VERTICAL_ALIGNMENT = {}));
export var BUTTONS_STYLE;
(function (BUTTONS_STYLE) {
    BUTTONS_STYLE[BUTTONS_STYLE["FULL"] = 1] = "FULL";
    BUTTONS_STYLE[BUTTONS_STYLE["HOLLOW"] = 2] = "HOLLOW";
    BUTTONS_STYLE[BUTTONS_STYLE["FULL_ROUNDED"] = 3] = "FULL_ROUNDED";
    BUTTONS_STYLE[BUTTONS_STYLE["HOLLOW_ROUNDED"] = 4] = "HOLLOW_ROUNDED";
})(BUTTONS_STYLE || (BUTTONS_STYLE = {}));
export var EVENT_FILTER_TYPE;
(function (EVENT_FILTER_TYPE) {
    EVENT_FILTER_TYPE[EVENT_FILTER_TYPE["MANUAL"] = 0] = "MANUAL";
    EVENT_FILTER_TYPE[EVENT_FILTER_TYPE["UPCOMING_AND_PAST"] = 1] = "UPCOMING_AND_PAST";
    EVENT_FILTER_TYPE[EVENT_FILTER_TYPE["UPCOMING"] = 2] = "UPCOMING";
    EVENT_FILTER_TYPE[EVENT_FILTER_TYPE["PAST"] = 3] = "PAST";
})(EVENT_FILTER_TYPE || (EVENT_FILTER_TYPE = {}));
export var EVENT_SORT_ORDER;
(function (EVENT_SORT_ORDER) {
    EVENT_SORT_ORDER[EVENT_SORT_ORDER["CHRONOLOGICAL"] = 0] = "CHRONOLOGICAL";
    EVENT_SORT_ORDER[EVENT_SORT_ORDER["MANUAL"] = 1] = "MANUAL";
})(EVENT_SORT_ORDER || (EVENT_SORT_ORDER = {}));
export var IMAGE_ALIGNMENT;
(function (IMAGE_ALIGNMENT) {
    IMAGE_ALIGNMENT[IMAGE_ALIGNMENT["TOP_LEFT"] = 1] = "TOP_LEFT";
    IMAGE_ALIGNMENT[IMAGE_ALIGNMENT["TOP_CENTER"] = 2] = "TOP_CENTER";
    IMAGE_ALIGNMENT[IMAGE_ALIGNMENT["TOP_RIGHT"] = 3] = "TOP_RIGHT";
    IMAGE_ALIGNMENT[IMAGE_ALIGNMENT["CENTER_LEFT"] = 4] = "CENTER_LEFT";
    IMAGE_ALIGNMENT[IMAGE_ALIGNMENT["CENTER"] = 5] = "CENTER";
    IMAGE_ALIGNMENT[IMAGE_ALIGNMENT["CENTER_RIGHT"] = 6] = "CENTER_RIGHT";
    IMAGE_ALIGNMENT[IMAGE_ALIGNMENT["BOTTOM_LEFT"] = 7] = "BOTTOM_LEFT";
    IMAGE_ALIGNMENT[IMAGE_ALIGNMENT["BOTTOM_CENTER"] = 8] = "BOTTOM_CENTER";
    IMAGE_ALIGNMENT[IMAGE_ALIGNMENT["BOTTOM_RIGHT"] = 9] = "BOTTOM_RIGHT";
})(IMAGE_ALIGNMENT || (IMAGE_ALIGNMENT = {}));
export var RECURRING_FILTER;
(function (RECURRING_FILTER) {
    RECURRING_FILTER[RECURRING_FILTER["COLLAPSED"] = 1] = "COLLAPSED";
    RECURRING_FILTER[RECURRING_FILTER["ALL"] = 2] = "ALL";
})(RECURRING_FILTER || (RECURRING_FILTER = {}));
//# sourceMappingURL=widget-settings-enums.js.map